import createSplash from 'screens/Splash/create';

const description = require('./description.md');

export default createSplash({
  description,
});